import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Accordion } from "react-bootstrap";
import parse from "html-react-parser";
import ProductOverview from "./product-overview";

const SolarBatteryDetails = ({ battery }) => {
  // render() {
  let publicUrl = process.env.PUBLIC_URL + "/";

  let modelId = battery?.id;
  const batterySpecifications = {
    "Main Parameters": {
      "Battery Type": "LiFePO4",
      Capacity: "100 AH",
      Voltage: "51.2 volts",
      "Operating Voltage Range": "43.2V to 57.6V",
      "Energy Storage": "5.12 kWh",
      "Usable Energy": "4.6 kWh",
      Display: "LCD Screen",
      "Battery Life": "6000 @ 0.5C (Temp 25°C, EOL 70%)",
    },
    "Charging & Discharging": {
      Recommended: "50 Amps",
      Maximum: "100 Amps",
      "Recommended Battery Usage": "Discharge Up to 90%",
    },
    Environment: {
      "Protection Rating": "IP21",
      "Altitude Limit": "< 2000m",
      "Storage Temperature": "0°C to 35°C",
      "Humidity Tolerance": "5% to 95%",
      "Operating Temperature": "-10°C to 50°C",
    },
    Connectivity: {
      Connectivity: "Wi-Fi (for cloud), CAN and RS485 (for inverter)",
    },
    Mechanical: {
      Weight: "50kg",
      Size: "580 x 520 x 190 mm",
      Installation: "Wall Mounted and Table Top",
    },
    Certifications: {
      Warranty: "5 Years",
      "Safety Standards": "UN38.3 Certified",
    },
  };

  const handleDownload = (fileName) => {
    const link = document.createElement("a");
    link.href = `/brochures/${fileName}`; // Path to the PDF file in public folder
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleUserManualDownload = (modelId) => {
    let fileName = "Battery-User-Manual.pdf"; // Default
    if (modelId === "2.5kwh-lifepo4") {
      fileName = "2.5kWh-Battery-User-Manual.pdf";
    } else if (modelId === "5kwh-lifepo4") {
      fileName = "5kWh-Battery-User-Manual.pdf";
    }

    const link = document.createElement("a");
    link.href = `/brochures/${fileName}`; // Path to the PDF file in public folder
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div className="ltn__shop-details-area pb-10">
      <div className="container">
        <ProductOverview overview={battery?.productOverview} />
        <div className="row">
          {/* Col - 1  */}
          <div className="col-lg-8 col-md-12">
            <div className="ltn__shop-details-inner ltn__page-details-inner mb-60">
              {/* <div className="ltn__blog-meta">
                  <ul>
                    <li className="ltn__blog-category">
                      <Link
                      >
                        Featured
                      </Link>
                    </li>
                    <li className="ltn__blog-category">
                      <Link
                        className="bg-orange"
                      >
                        Power Your life with Atom Power
                      </Link>
                    </li>
                  </ul>
                </div> */}
              <div className="ltn__blog-meta mt-2">
                <ul>
                  <li style={{ marginBottom: "6px" }}>
                    <button
                      onClick={() => handleDownload("battery-flyer.pdf")} // Replace with actual file name
                      className="btn btn-success d-flex align-items-center"
                      style={{
                        gap: "10px",
                        fontWeight: "light",
                        padding: "10px 15px",
                        backgroundColor: "red",
                        border: "none",
                      }}
                    >
                      Download Brochure
                      <i
                        className="fas fa-download"
                        style={{ color: "white" }}
                      ></i>
                    </button>
                  </li>

                  <li>
                    <button
                      onClick={() => handleUserManualDownload(modelId)} // Replace with actual file name
                      className="btn btn-success d-flex align-items-center"
                      style={{
                        gap: "10px",
                        fontWeight: "light",
                        padding: "10px 15px",
                        backgroundColor: "red",
                        border: "none",
                      }}
                    >
                      Download User Manual
                      <i
                        className="fas fa-download"
                        style={{ color: "white" }}
                      ></i>
                    </button>
                  </li>
                </ul>
              </div>
              <h1>Solar Battery : {battery?.name}</h1>
              {/* <label>
                  <span className="ltn__secondary-color">
                    <i className="flaticon-pin" />
                  </span>
                  A Smart Battery Solution for Reliable, Everyday Energy
                  Storage!
                </label> */}
              {Array.isArray(battery.description) ? (
                <>
                  {battery.description.map((section, idx) => (
                    <div key={idx}>
                      {section.title && <h5>{section.title}</h5>}
                      <p>{section.text}</p>
                    </div>
                  ))}
                </>
              ) : (
                <>
                  <h4>Description</h4>
                  <p>{battery.description}</p>
                </>
              )}

              {/* Accordion for Technical Specifications */}
              <h4>Technical Specifications</h4>
              <Accordion defaultActiveKey="0">
                {Object.entries(battery.specifications).map(
                  ([category, details], index) => (
                    <Accordion.Item eventKey={index.toString()} key={category}>
                      <Accordion.Header>{category}</Accordion.Header>
                      <Accordion.Body>
                        <ul className="list-group list-group-flush">
                          {Object.entries(details).map(([key, value]) => (
                            <li
                              key={key}
                              className="list-group-item d-flex justify-content-between"
                            >
                              <span className="fw-bold">{key}:</span>{" "}
                              <span>{value}</span>
                            </li>
                          ))}
                        </ul>
                      </Accordion.Body>
                    </Accordion.Item>
                  )
                )}
              </Accordion>

              {/* <h4 className="title-2">Battery Specifications</h4>
                <div
                  className="property-detail-info-list section-bg-1 clearfix mb-60"
                  style={{ display: "flex", gap: "20px" }}
                >
                  <ul style={{ flex: "1" }}>
                    <li>
                      <label>Battery Type:</label> <span>LiFePO4</span>
                    </li>
                    <li>
                      <label>Capacity:</label> <span>100 AH</span>
                    </li>
                    <li>
                      <label>Voltage:</label> <span>51.2 volts</span>
                    </li>
                    <li>
                      <label>Operating Voltage Range:</label>{" "}
                      <span>43.2V to 57.6V</span>
                    </li>
                    <li>
                      <label>Energy Storage:</label> <span>5.12 kWh</span>
                    </li>
                  </ul>
                  <ul style={{ flex: "1" }}>
                    <li>
                      <label>Usable Energy:</label> <span>4.6 kWh</span>
                    </li>
                    <li>
                      <label>Display:</label> <span>LCD Screen</span>
                    </li>
                    <li>
                      <label>Battery Life:</label>{" "}
                      <span>6000 @ 0.5C (Temp 25°C, EOL 70%)</span>
                    </li>
                  </ul>
                </div> */}

              {/* Portal changes */}

              {/* <h4>App and Web Portal for End Users</h4>

                <p>
                  Intuitive power flow monitoring - Say Goodbye to high energy
                  bills with Self-Powered Mode
                </p>

                <p>
                  Viewing power generation and consumption data through an
                  application
                </p>

                <p>
                  Comprehensive and detailed data to assist you in system fault
                  analysis
                </p> */}

              {/* <div className="property-detail-feature-list clearfix mb-45">
                  <ul>
                    <li>
                      <div className="property-detail-feature-list-item">
                        <i className="flaticon-double-bed" />
                        <div>
                          <h6>Living Room</h6>
                          <small>20 x 16 sq feet</small>
                        </div>
                      </div>
                    </li>
                    <li>
                      <div className="property-detail-feature-list-item">
                        <i className="flaticon-double-bed" />
                        <div>
                          <h6>Garage</h6>
                          <small>20 x 16 sq feet</small>
                        </div>
                      </div>
                    </li>
                    <li>
                      <div className="property-detail-feature-list-item">
                        <i className="flaticon-double-bed" />
                        <div>
                          <h6>Dining Area</h6>
                          <small>20 x 16 sq feet</small>
                        </div>
                      </div>
                    </li>
                    <li>
                      <div className="property-detail-feature-list-item">
                        <i className="flaticon-double-bed" />
                        <div>
                          <h6>Bedroom</h6>
                          <small>20 x 16 sq feet</small>
                        </div>
                      </div>
                    </li>
                    <li>
                      <div className="property-detail-feature-list-item">
                        <i className="flaticon-double-bed" />
                        <div>
                          <h6>Bathroom</h6>
                          <small>20 x 16 sq feet</small>
                        </div>
                      </div>
                    </li>
                    <li>
                      <div className="property-detail-feature-list-item">
                        <i className="flaticon-double-bed" />
                        <div>
                          <h6>Gym Area</h6>
                          <small>20 x 16 sq feet</small>
                        </div>
                      </div>
                    </li>
                    <li>
                      <div className="property-detail-feature-list-item">
                        <i className="flaticon-double-bed" />
                        <div>
                          <h6>Garden</h6>
                          <small>20 x 16 sq feet</small>
                        </div>
                      </div>
                    </li>
                    <li>
                      <div className="property-detail-feature-list-item">
                        <i className="flaticon-double-bed" />
                        <div>
                          <h6>Parking</h6>
                          <small>20 x 16 sq feet</small>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div> */}
              <h4>From Our Gallery</h4>
              <div className="ltn__property-details-gallery mb-30">
                <div className="row">
                  {/* Left Column - First 2 Images */}
                  <div className="col-md-6">
                    {battery.gallery.slice(0, 2).map((imgSrc, index) => (
                      <img
                        key={index}
                        className="mb-30"
                        src={process.env.PUBLIC_URL + imgSrc}
                        alt={`Gallery ${index + 1}`}
                      />
                    ))}
                  </div>

                  {/* Right Column - Next 1 Image */}
                  <div className="col-md-6 " style={{height:"450px"}}>
                    {battery.gallery.slice(2, 3).map((imgSrc, index) => (
                      <img
                        key={index}
                        style={{height:"100%"}}
                        className="mb-30 h-full"
                        src={process.env.PUBLIC_URL + imgSrc}
                        alt={`Gallery ${index + 3}`}
                      />
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* Col - 2 */}
          <div className="col-lg-4 col-md-12">
            <aside className="sidebar ltn__shop-sidebar ltn__right-sidebar---">
              {/* Author Widget */}
              {/* <div className="widget ltn__author-widget">
                              <div className="ltn__author-widget-inner text-center">
                                <img
                                  src={publicUrl + "assets/img/team/4.jpg"}
                                  alt="Image"
                                />
                                <h5>Rosalina D. Willaimson</h5>
                                <small>Traveller/Photographer</small>
                                <div className="product-ratting">
                                  <ul>
                                    <li>
                                      <a href="#">
                                        <i className="fas fa-star" />
                                      </a>
                                    </li>
                                    <li>
                                      <a href="#">
                                        <i className="fas fa-star" />
                                      </a>
                                    </li>
                                    <li>
                                      <a href="#">
                                        <i className="fas fa-star" />
                                      </a>
                                    </li>
                                    <li>
                                      <a href="#">
                                        <i className="fas fa-star-half-alt" />
                                      </a>
                                    </li>
                                    <li>
                                      <a href="#">
                                        <i className="far fa-star" />
                                      </a>
                                    </li>
                                    <li className="review-total">
                                      {" "}
                                      <a href="#"> ( 1 Reviews )</a>
                                    </li>
                                  </ul>
                                </div>
                                <p>
                                  Lorem ipsum dolor sit amet, consectetur adipisicing elit.
                                  Veritatis distinctio, odio, eligendi suscipit
                                  reprehenderit atque.
                                </p>
                                <div className="ltn__social-media">
                                  <ul>
                                    <li>
                                      <a href="#" title="Facebook">
                                        <i className="fab fa-facebook-f" />
                                      </a>
                                    </li>
                                    <li>
                                      <a href="#" title="Twitter">
                                        <i className="fab fa-twitter" />
                                      </a>
                                    </li>
                                    <li>
                                      <a href="#" title="Linkedin">
                                        <i className="fab fa-linkedin" />
                                      </a>
                                    </li>
                                    <li>
                                      <a href="#" title="Youtube">
                                        <i className="fab fa-youtube" />
                                      </a>
                                    </li>
                                  </ul>
                                </div>
                              </div>
                            </div> */}
              {/* Search Widget */}
              {/* <div className="widget ltn__search-widget">
                              <h4 className="ltn__widget-title ltn__widget-title-border-2">
                                Search Objects
                              </h4>
                              <form action="#">
                                <input
                                  type="text"
                                  name="search"
                                  placeholder="Search your keyword..."
                                />
                                <button type="submit">
                                  <i className="fas fa-search" />
                                </button>
                              </form>
                            </div> */}
              {/* Form Widget */}
              {/* <div className="widget ltn__form-widget">
                              <h4 className="ltn__widget-title ltn__widget-title-border-2">
                                Drop Messege For Book
                              </h4>
                              <form action="#">
                                <input
                                  type="text"
                                  name="yourname"
                                  placeholder="Your Name*"
                                />
                                <input
                                  type="text"
                                  name="youremail"
                                  placeholder="Your e-Mail*"
                                />
                                <textarea
                                  name="yourmessage"
                                  placeholder="Write Message..."
                                  defaultValue={""}
                                />
                                <button type="submit" className="btn theme-btn-1">
                                  Send Messege
                                </button>
                              </form>
                            </div> */}
              {/* Top Rated Product Widget */}
              {/* <div className="widget ltn__top-rated-product-widget go-top">
                              <h4 className="ltn__widget-title ltn__widget-title-border-2">
                                Top Rated Product
                              </h4>
                              <ul>
                                <li>
                                  <div className="top-rated-product-item clearfix">
                                    <div className="top-rated-product-img">
                                      <Link to="/product-details">
                                        <img
                                          src={publicUrl + "assets/img/product/1.png"}
                                          alt="#"
                                        />
                                      </Link>
                                    </div>
                                    <div className="top-rated-product-info">
                                      <div className="product-ratting">
                                        <ul>
                                          <li>
                                            <a href="#">
                                              <i className="fas fa-star" />
                                            </a>
                                          </li>
                                          <li>
                                            <a href="#">
                                              <i className="fas fa-star" />
                                            </a>
                                          </li>
                                          <li>
                                            <a href="#">
                                              <i className="fas fa-star" />
                                            </a>
                                          </li>
                                          <li>
                                            <a href="#">
                                              <i className="fas fa-star" />
                                            </a>
                                          </li>
                                          <li>
                                            <a href="#">
                                              <i className="fas fa-star" />
                                            </a>
                                          </li>
                                        </ul>
                                      </div>
                                      <h6>
                                        <Link to="/shop">Luxury House In Greenville </Link>
                                      </h6>
                                      <div className="product-price">
                                        <span>$30,000.00</span>
                                        <del>$35,000.00</del>
                                      </div>
                                    </div>
                                  </div>
                                </li>
                                <li>
                                  <div className="top-rated-product-item clearfix">
                                    <div className="top-rated-product-img">
                                      <Link to="/product-details">
                                        <img
                                          src={publicUrl + "assets/img/product/2.png"}
                                          alt="#"
                                        />
                                      </Link>
                                    </div>
                                    <div className="top-rated-product-info">
                                      <div className="product-ratting">
                                        <ul>
                                          <li>
                                            <a href="#">
                                              <i className="fas fa-star" />
                                            </a>
                                          </li>
                                          <li>
                                            <a href="#">
                                              <i className="fas fa-star" />
                                            </a>
                                          </li>
                                          <li>
                                            <a href="#">
                                              <i className="fas fa-star" />
                                            </a>
                                          </li>
                                          <li>
                                            <a href="#">
                                              <i className="fas fa-star" />
                                            </a>
                                          </li>
                                          <li>
                                            <a href="#">
                                              <i className="fas fa-star" />
                                            </a>
                                          </li>
                                        </ul>
                                      </div>
                                      <h6>
                                        <Link to="/shop">Apartment with Subunits</Link>
                                      </h6>
                                      <div className="product-price">
                                        <span>$30,000.00</span>
                                        <del>$35,000.00</del>
                                      </div>
                                    </div>
                                  </div>
                                </li>
                                <li>
                                  <div className="top-rated-product-item clearfix">
                                    <div className="top-rated-product-img">
                                      <Link to="/product-details">
                                        <img
                                          src={publicUrl + "assets/img/product/3.png"}
                                          alt="#"
                                        />
                                      </Link>
                                    </div>
                                    <div className="top-rated-product-info">
                                      <div className="product-ratting">
                                        <ul>
                                          <li>
                                            <a href="#">
                                              <i className="fas fa-star" />
                                            </a>
                                          </li>
                                          <li>
                                            <a href="#">
                                              <i className="fas fa-star" />
                                            </a>
                                          </li>
                                          <li>
                                            <a href="#">
                                              <i className="fas fa-star" />
                                            </a>
                                          </li>
                                          <li>
                                            <a href="#">
                                              <i className="fas fa-star-half-alt" />
                                            </a>
                                          </li>
                                          <li>
                                            <a href="#">
                                              <i className="far fa-star" />
                                            </a>
                                          </li>
                                        </ul>
                                      </div>
                                      <h6>
                                        <Link to="/shop">3 Rooms Manhattan</Link>
                                      </h6>
                                      <div className="product-price">
                                        <span>$30,000.00</span>
                                        <del>$35,000.00</del>
                                      </div>
                                    </div>
                                  </div>
                                </li>
                              </ul>
                            </div> */}
              {/* Menu Widget (Category) */}
              {/* <div className="widget ltn__menu-widget ltn__menu-widget-2--- ltn__menu-widget-2-color-2---">
                              <h4 className="ltn__widget-title ltn__widget-title-border-2">
                                Top Categories
                              </h4>
                              <ul className="go-top">
                                <li>
                                  <Link to="/blog-grid">
                                    Apartments <span>(26)</span>
                                  </Link>
                                </li>
                                <li>
                                  <Link to="/blog-grid">
                                    Picture Stodio <span>(30)</span>
                                  </Link>
                                </li>
                                <li>
                                  <Link to="/blog-grid">
                                    Office <span>(71)</span>
                                  </Link>
                                </li>
                                <li>
                                  <Link to="/blog-grid">
                                    Luxary Vilas <span>(56)</span>
                                  </Link>
                                </li>
                                <li>
                                  <Link to="/blog-grid">
                                    Duplex House <span>(60)</span>
                                  </Link>
                                </li>
                              </ul>
                            </div> */}
              {/* Popular Product Widget */}
              <div className="widget ltn__popular-product-widget">
                <h4 className="ltn__widget-title ltn__widget-title-border-2">
                  Atom Power Battery Dashboard
                </h4>
                <div className="row ltn__popular-product-widget-active slick-arrow-1">
                  {/* ltn__product-item */}
                  <div className="col-12">
                    <div className="ltn__product-item ltn__product-item-4 ltn__product-item-5 text-center---">
                      <div className="product-img go-top">
                        <a
                          href="https://dashboard.atom-power.com/login/"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <img
                            src={
                              publicUrl + "assets/img/product-3/atom.webp"
                            }
                            alt="Atom Power Battery Dashboard"
                          />
                        </a>
                      </div>
                      <div className="product-info">
                        <p>
                          Effortlessly track your Atom Power Battery health and status in real time through our proprietary Smart Dashboard. Gain Real-Time Battery Insights, Anytime, Anywhere, ensuring continuous optimization and ultimate power reliability.
                        </p>
                        {/* <div className="product-img-location">
                                        <ul>
                                          <li>
                                            <Link to="/shop">
                                              <i className="flaticon-pin" /> Belmont
                                              Gardens, Chicago
                                            </Link>
                                          </li>
                                        </ul>
                                      </div> */}
                        {/* <ul className="ltn__list-item-2--- ltn__list-item-2-before--- ltn__plot-brief">
                                        <li>
                                          <span>3 </span>
                                          Bedrooms
                                        </li>
                                        <li>
                                          <span>2 </span>
                                          Bathrooms
                                        </li>
                                        <li>
                                          <span>3450 </span>
                                          square Ft
                                        </li>
                                      </ul> */}
                      </div>
                    </div>
                  </div>
                  {/* ltn__product-item */}
                  {/* <div className="col-12">
                                  <div className="ltn__product-item ltn__product-item-4 ltn__product-item-5 text-center---">
                                    <div className="product-img">
                                      <a href="product-details.html">
                                        <img
                                          src={publicUrl + "assets/img/product-3/4.jpg"}
                                          alt="#"
                                        />
                                      </a>
                                      <div className="real-estate-agent">
                                        <div className="agent-img">
                                          <Link to="/team-details">
                                            <img
                                              src={publicUrl + "assets/img/blog/author.jpg"}
                                              alt="#"
                                            />
                                          </Link>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="product-info">
                                      <div className="product-price">
                                        <span>
                                          $349,00<label>/Month</label>
                                        </span>
                                      </div>
                                      <h2 className="product-title">
                                        <a href="product-details.html">
                                          New Apartment Nice View
                                        </a>
                                      </h2>
                                      <div className="product-img-location">
                                        <ul>
                                          <li>
                                            <a href="product-details.html">
                                              <i className="flaticon-pin" /> Belmont
                                              Gardens, Chicago
                                            </a>
                                          </li>
                                        </ul>
                                      </div>
                                      <ul className="ltn__list-item-2--- ltn__list-item-2-before--- ltn__plot-brief">
                                        <li>
                                          <span>3 </span>
                                          Bedrooms
                                        </li>
                                        <li>
                                          <span>2 </span>
                                          Bathrooms
                                        </li>
                                        <li>
                                          <span>3450 </span>
                                          square Ft
                                        </li>
                                      </ul>
                                    </div>
                                  </div>
                                </div> */}
                  {/* ltn__product-item */}
                  {/* <div className="col-12">
                                  <div className="ltn__product-item ltn__product-item-4 ltn__product-item-5 text-center---">
                                    <div className="product-img">
                                      <a href="product-details.html">
                                        <img
                                          src={publicUrl + "assets/img/product-3/5.jpg"}
                                          alt="#"
                                        />
                                      </a>
                                      <div className="real-estate-agent">
                                        <div className="agent-img">
                                          <Link to="/team-details">
                                            <img
                                              src={publicUrl + "assets/img/blog/author.jpg"}
                                              alt="#"
                                            />
                                          </Link>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="product-info">
                                      <div className="product-price">
                                        <span>
                                          $349,00<label>/Month</label>
                                        </span>
                                      </div>
                                      <h2 className="product-title">
                                        <a href="product-details.html">
                                          New Apartment Nice View
                                        </a>
                                      </h2>
                                      <div className="product-img-location">
                                        <ul>
                                          <li>
                                            <a href="product-details.html">
                                              <i className="flaticon-pin" /> Belmont
                                              Gardens, Chicago
                                            </a>
                                          </li>
                                        </ul>
                                      </div>
                                      <ul className="ltn__list-item-2--- ltn__list-item-2-before--- ltn__plot-brief">
                                        <li>
                                          <span>3 </span>
                                          Bedrooms
                                        </li>
                                        <li>
                                          <span>2 </span>
                                          Bathrooms
                                        </li>
                                        <li>
                                          <span>3450 </span>
                                          square Ft
                                        </li>
                                      </ul>
                                    </div>
                                  </div>
                                </div> */}
                  {/*  */}
                </div>
              </div>
              {/* Popular Post Widget */}
              {/* <div className="widget ltn__popular-post-widget go-top">
                              <h4 className="ltn__widget-title ltn__widget-title-border-2">
                                Leatest Blogs
                              </h4>
                              <ul>
                                <li>
                                  <div className="popular-post-widget-item clearfix">
                                    <div className="popular-post-widget-img">
                                      <Link to="/blog-details">
                                        <img
                                          src={publicUrl + "assets/img/team/5.jpg"}
                                          alt="#"
                                        />
                                      </Link>
                                    </div>
                                    <div className="popular-post-widget-brief">
                                      <h6>
                                        <Link to="/blog-details">
                                          Lorem ipsum dolor sit cing elit, sed do.
                                        </Link>
                                      </h6>
                                      <div className="ltn__blog-meta">
                                        <ul>
                                          <li className="ltn__blog-date">
                                            <a href="#">
                                              <i className="far fa-calendar-alt" />
                                              June 22, 2020
                                            </a>
                                          </li>
                                        </ul>
                                      </div>
                                    </div>
                                  </div>
                                </li>
                                <li>
                                  <div className="popular-post-widget-item clearfix">
                                    <div className="popular-post-widget-img">
                                      <Link to="/blog-details">
                                        <img
                                          src={publicUrl + "assets/img/team/6.jpg"}
                                          alt="#"
                                        />
                                      </Link>
                                    </div>
                                    <div className="popular-post-widget-brief">
                                      <h6>
                                        <Link to="/blog-details">
                                          Lorem ipsum dolor sit cing elit, sed do.
                                        </Link>
                                      </h6>
                                      <div className="ltn__blog-meta">
                                        <ul>
                                          <li className="ltn__blog-date">
                                            <a href="#">
                                              <i className="far fa-calendar-alt" />
                                              June 22, 2020
                                            </a>
                                          </li>
                                        </ul>
                                      </div>
                                    </div>
                                  </div>
                                </li>
                                <li>
                                  <div className="popular-post-widget-item clearfix">
                                    <div className="popular-post-widget-img">
                                      <Link to="/blog-details">
                                        <img
                                          src={publicUrl + "assets/img/team/7.jpg"}
                                          alt="#"
                                        />
                                      </Link>
                                    </div>
                                    <div className="popular-post-widget-brief">
                                      <h6>
                                        <Link to="/blog-details">
                                          Lorem ipsum dolor sit cing elit, sed do.
                                        </Link>
                                      </h6>
                                      <div className="ltn__blog-meta">
                                        <ul>
                                          <li className="ltn__blog-date">
                                            <a href="#">
                                              <i className="far fa-calendar-alt" />
                                              June 22, 2020
                                            </a>
                                          </li>
                                        </ul>
                                      </div>
                                    </div>
                                  </div>
                                </li>
                                <li>
                                  <div className="popular-post-widget-item clearfix">
                                    <div className="popular-post-widget-img">
                                      <Link to="/blog-details">
                                        <img
                                          src={publicUrl + "assets/img/team/8.jpg"}
                                          alt="#"
                                        />
                                      </Link>
                                    </div>
                                    <div className="popular-post-widget-brief">
                                      <h6>
                                        <Link to="/blog-details">
                                          Lorem ipsum dolor sit cing elit, sed do.
                                        </Link>
                                      </h6>
                                      <div className="ltn__blog-meta">
                                        <ul>
                                          <li className="ltn__blog-date">
                                            <a href="#">
                                              <i className="far fa-calendar-alt" />
                                              June 22, 2020
                                            </a>
                                          </li>
                                        </ul>
                                      </div>
                                    </div>
                                  </div>
                                </li>
                              </ul>
                            </div> */}
              {/* Social Media Widget */}
              {/* <div className="widget ltn__social-media-widget">
                              <h4 className="ltn__widget-title ltn__widget-title-border-2">
                                Follow us
                              </h4>
                              <div className="ltn__social-media-2">
                                <ul>
                                  <li>
                                    <a href="#" title="Facebook">
                                      <i className="fab fa-facebook-f" />
                                    </a>
                                  </li>
                                  <li>
                                    <a href="#" title="Twitter">
                                      <i className="fab fa-twitter" />
                                    </a>
                                  </li>
                                  <li>
                                    <a href="#" title="Linkedin">
                                      <i className="fab fa-linkedin" />
                                    </a>
                                  </li>
                                  <li>
                                    <a href="#" title="Instagram">
                                      <i className="fab fa-instagram" />
                                    </a>
                                  </li>
                                </ul>
                              </div>
                            </div> */}
              {/* Tagcloud Widget */}
              {/* <div className="widget ltn__tagcloud-widget go-top">
                              <h4 className="ltn__widget-title ltn__widget-title-border-2">
                                Popular Tags
                              </h4>
                              <ul>
                                <li>
                                  <Link to="/blog-grid">Popular</Link>
                                </li>
                                <li>
                                  <Link to="/blog-grid">desgin</Link>
                                </li>
                                <li>
                                  <Link to="/blog-grid">ux</Link>
                                </li>
                                <li>
                                  <Link to="/blog-grid">usability</Link>
                                </li>
                                <li>
                                  <Link to="/blog-grid">develop</Link>
                                </li>
                                <li>
                                  <Link to="/blog-grid">icon</Link>
                                </li>
                                <li>
                                  <Link to="/blog-grid">Car</Link>
                                </li>
                                <li>
                                  <Link to="/blog-grid">Service</Link>
                                </li>
                                <li>
                                  <Link to="/blog-grid">Repairs</Link>
                                </li>
                                <li>
                                  <Link to="/blog-grid">Auto Parts</Link>
                                </li>
                                <li>
                                  <Link to="/blog-grid">Oil</Link>
                                </li>
                                <li>
                                  <Link to="/blog-grid">Dealer</Link>
                                </li>
                                <li>
                                  <Link to="/blog-grid">Oil Change</Link>
                                </li>
                                <li>
                                  <Link to="/blog-grid">Body Color</Link>
                                </li>
                              </ul>
                            </div> */}
              {/* Banner Widget */}
              {/* <div className="widget ltn__banner-widget d-none go-top">
                              <Link to="/shop">
                                <img src={publicUrl + "assets/img/banner/2.jpg"} alt="#" />
                              </Link>
                            </div> */}
            </aside>
          </div>
        </div>
      </div>
    </div>
  );
  // }
};

export default SolarBatteryDetails;
